module.exports = __webpack_public_path__ + "static/presence-7faa1bd64935f1a368ade0d7f854ab3a.jpg";